import { useEffect } from 'react';
import { useFeedStore } from '@/stores/feed';
import { PostComposer } from '@/components/PostComposer';
import { PostCard } from '@/components/PostCard';
import { LeftSidebar } from '@/components/LeftSidebar';
import { RightSidebar } from '@/components/RightSidebar';

export function FeedPage() {
  const { posts, loading, hasMore, sort, setSort, fetchFeed } = useFeedStore();

  useEffect(() => {
    fetchFeed(true);
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-3 py-4 flex gap-4">
      {/* Left sidebar — profile card + nav */}
      <LeftSidebar />

      {/* Center feed */}
      <div className="flex-1 min-w-0">
        <PostComposer />

        {/* Sort toggle */}
        <div className="card mb-3 px-3 py-2 flex items-center gap-1 text-xs">
          <span className="text-sand-500 mr-1">Sort:</span>
          <button
            onClick={() => setSort('recent')}
            className={`px-2 py-0.5 rounded font-bold transition-colors ${
              sort === 'recent'
                ? 'bg-vibe-100 text-vibe-600'
                : 'text-sand-500 hover:text-sand-700'
            }`}
          >
            Most Recent
          </button>
          <span className="text-sand-300">|</span>
          <button
            onClick={() => setSort('top')}
            className={`px-2 py-0.5 rounded font-bold transition-colors ${
              sort === 'top'
                ? 'bg-vibe-100 text-vibe-600'
                : 'text-sand-500 hover:text-sand-700'
            }`}
          >
            Top News
          </button>
        </div>

        {posts.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
        {loading && <p className="text-center text-sand-500 text-xs py-4">Catching waves ∿</p>}
        {hasMore && !loading && posts.length > 0 && (
          <button onClick={() => fetchFeed()} className="btn-secondary w-full text-xs">
            More vibes
          </button>
        )}
        {!loading && posts.length === 0 && (
          <div className="text-center py-8 text-sand-500">
            <div className="text-3xl mb-2">〰️</div>
            <p className="text-sm">It's quiet here. Start the first ripple ∿</p>
          </div>
        )}
      </div>

      {/* Right sidebar — online friends, birthdays, events */}
      <RightSidebar />
    </div>
  );
}
